﻿var cacheVersion = 1;
var savedTimes = {};

function isVisible(elem) {
    return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
}

addDomReadyEventListener(() => {
    document.body.addEventListener('keyup', function (e) {
        if (e.key === 'Tab') {
            let el = document.documentElement;
            el.classList.remove('nfo');
            el.classList.add('tab');
        }
    });
});

function printError(level, ...args) {
    let errors = document.querySelector("#errors");
    if (errors) {
        let html = `<code class="${(level > 0 ? `level${level}` : '')}">`;
        args.forEach((a, i) => {
            html += `${typeof a == "string" ? a : (isElement(a) ? escapeHTML(a.outerHTML) : JSON.stringify(a, null, 2))}${i < (args.length - 1) ? " | " : ""}`;
        });
        errors.insertAdjacentHTML("afterbegin", html + "</code>\n");
    }
}

urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results === null) {
        return null;
    }
    else {
        return decodeURIComponent(results[1]) || 0;
    }
};

function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function parseTimeStampCookie(u) {
    let timeStamps = useTimestamps ? getCookie("TimeStamps") : undefined;
    if (timeStamps && timeStamps.startsWith("[")) {
        try {
            let parsed = JSON.parse(timeStamps);
            let lc = [];
            forEach(parsed, function (ts) {
                lc.push({ "note": ts.Note, "milliseconds": ts.Milliseconds });
            });
            try {
                showTimestamps({ "timeStamps": lc }, u);
            }
            catch (exi) {
                customLog(2, "showtimestamps failed", exi);
            }
        }
        catch (ex) {
            customLog(2, "timestamp parse failed", ex);
        }
    }
}

function showTimestamps(data, heading) {
    if (isDebug && data.timeStamps) {
        let pre = document.getElementById("debugpre");
        if (!pre) {
            pre = document.createElement('pre');
            pre.id = "debugpre"
            pre.classList.add("debugpre");
            if (!isLocal) pre.classList.add("compact");
            document.body.appendChild(pre);
        }
        if (!pre.classList.contains("hasevent")) {
            pre.addEventListener("contextmenu", (e) => {
                e.target.classList.toggle("compact");
                stopAll(e);
            });
            pre.classList.add("hasevent");
        }

        document.querySelectorAll(".debugpre:not(.active)")?.forEach(el => {
            el.addEventListener("contextmenu", e => {
                e.target.classList.toggle("compact");
                stopAll(e);
                return false;
            });
            el.classList.add("active");
        });

        let s = "";
        if (jsTodayIsoDateString != new Date().isoDate()) s += `\n"TODAY" is ${jsTodayIsoDateString}\n\n`;
        if (heading) s += ('\n' + heading).split(".dk").slice(-1) + "\n";
        s += `Memberid ${document.querySelector("body").dataset.memberid}\n\n`;

        forEach(data.timeStamps, function (t) {
            s += ("000000" + t.milliseconds).slice(-6) + " " + t.note + "\n";
        });
        pre.insertAdjacentHTML("beforeend", s);
    }
}

function handleResponse(url, result, callback, postdata, source, eventExtra, isFetch) {
    let u = url.split('?');
    if (u.length > 1) u = u[1];

    let goal = url.split('/').pop().split('?').pop();

    let postdataLength = 0;
    if (typeof postdata === "string") {
        postdataLength = postdata.length;
    }

    if (goal && goal.length > 0 && (goal.indexOf('=') > 0 || url.indexOf("umbraco") > 0) && (postdata instanceof FormData || postdataLength > 3)) {
        goal = goal.split('=').pop();
        goal += source && source.getAttribute("eventextra") ? source.getAttribute("eventextra") : "";
        if (eventExtra) goal += eventExtra;
        plausible(goal);
    }

    parseTimeStampCookie(u);
    source?.querySelector("input[type=submit]")?.removeAttribute("disabled");

    let data = result;
    if (result && result.length > 5 && result.substring(0, 5) === "error") {
        if (result.length > 14 && result.substring(0, 14) === "error.internal") {
            showApiError(result, true, url);
        }
        else {
            showApiError(result, false);
        }
        return true;
    }
    if (result && result.length > 5 && result.indexOf("<form") >= 0) {
        if (result.substring(0, 5) !== "<form") result = result.substring(result.indexOf("<form"), result.indexOf("</form>") + 7);
        let body = document.querySelector("body");
        let div = document.createElement("div");
        addClass(div, "hidden");
        div.innerHTML = result;
        body.appendChild(div);
        body.lastChild.firstChild.submit();
        return true;
    }
    if (result && result.length > 1 && result.substring(0, 1) !== "<") {
        try {
            data = JSON.parse(result);
            if (data.messages && data.messages.length) {
                showApiMessages(data.messages);
            }
        }
        catch (ex) {
            data = result;
        }
    }
    if (result && result.length > 4 && (result.substr(0, 4) === "url:" || result.indexOf("url:") > 0)) {
        if (navigator.userAgent.indexOf("Firefox") != -1) {
            setTimeout(function () { document.location.href = result.substr(result.indexOf("url:") + 4); }, 100);
        }
        else {
            document.location.href = result.substr(result.indexOf("url:") + 4);
        }
        return true;
    }
    if (callback) {
        callback(data, source);
    }
    else if (source) {
        let result = source.querySelector(".result[data-status='" + data + "']");
        if (result) {
            let url = result.getAttribute("data-url");
            if (url) {
                if (navigator.userAgent.indexOf("Firefox") != -1) {
                    setTimeout(function () { document.location = url; }, 100);
                }
                else {
                    document.location = url;
                }
            }
            else {
                forEach(source.querySelectorAll(".result"), function (el) {
                    removeClass(el, "active");
                });
                addClass(result, "active");
                scrollToElement(result);
            }
        }
    }
}

function handleError(msg, url, data, error, callback = undefined, source = undefined) {
    customLog(2, msg, url, data, error);
    document.querySelector("html").classList.remove("jsshow");
    showApiError(genericError, false);
    source?.querySelector("input[type=submit]")?.removeAttribute("disabled");
    if (callback) callback(-1);
}

async function httpr(url, callback, postdata, source, eventExtra) {
    if (isDebug) {
        let u = url.split('?');
        if (u.length > 1) u = u[1];
        savedTimes[u] = new Date().getTime();
    }

    if (url === "/umbraco/surface/vctasurface/buy" && postdata && source) {
        sendQuantity(source.querySelector("input.product"));
    }

    let fetchAvailable = (typeof fetch !== 'undefined');

    source?.querySelectorAll(".result.active").forEach((el) => el.classList.remove("active"));
    source?.querySelector("input[type=submit]")?.setAttribute("disabled", "disabled");

    let aft = afToken()?.value;
    if (postdata && typeof postdata !== "string") {
        postdata.append("__RequestVerificationToken", aft);
    }

    let method = postdata !== undefined ? 'POST' : 'GET';
    if (fetchAvailable) {
        let responseUrl = url;
        let headers = {};
        if (method == "POST") headers["X-CSRF-TOKEN"] = aft;
        fetch(url, {
            method: method,
            headers: headers,
            body: postdata ? postdata : null
        }).then(response => {
            if (!response.ok) {
                handleError("Network response was not ok", response.url, undefined, undefined, callback, source)
            }
            responseUrl = response.url;
            return response.text();
        }).then(data => {
            handleResponse(responseUrl, data, callback, postdata, source, eventExtra, true);
        }).catch(error => {
            handleError("apierror", url, undefined, error, callback, source)
        });
    } else {
        let request = new XMLHttpRequest();
        request.open(method, url, true);
        if (method == 'POST') request.setRequestHeader('X-CSRF-TOKEN', aft);
        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                handleResponse(request.responseURL, request.responseText, callback, postdata, source, eventExtra, false);
            } else {
                handleError("apierror", url, undefined, error, callback, source)
            }
        };

        request.onerror = function (data) {
            handleError("onerror", url, data, undefined, callback, source)
        };

        if (postdata !== undefined) {
            try {
                request.send(postdata);
            }
            catch (ex) {
                handleError("onerror", url, undefined, ex, callback, source)
            }
        }
        else {
            request.send();
        }
    }
}

function afToken() {
    return document.querySelector('input[name=__RequestVerificationToken');
}

function scrollToElement(el) {
    let p = el.getBoundingClientRect().top + window.scrollY - 100;

    if (isIE()) {
        window.scrollTo(0, p);
    }
    else {
        window.scrollTo({
            top: p,
            behavior: "smooth"
        });
    }
}

function cssVar(v) {
    return window.getComputedStyle(document.documentElement).getPropertyValue('--' + v);
}

function _log(s, alwaysShow) {
    if (enableLog && console && (alwaysShow === true || enableLogDebug)) {
        console.log(s);
    }
}

var forEach = function (arr, callback) {
    if (typeof arr === "string") arr = document.querySelectorAll(arr);
    Array.prototype.forEach.call(arr, callback);
};

var hasClass, addClass, removeClass;
hasClass = function (el, className) { return el?.classList.contains(className); };
addClass = function (el, className) { if (!el) return; el.classList.add(className); };
removeClass = function (el, className) { if (!el) return; el.classList.remove(className); };

function addEvent(path, event, func) {
    let el = document.querySelector(path);
    if (el) {
        el.addEventListener(event, func);
    }
}

function addEvents(path, event, func) {
    forEach(path, function (el) {
        el.addEventListener(event, func);
    });
}

    function toggleClass(el, className) {
        if (typeof el === "string") el = document.querySelector(el);

        if (hasClass(el, className)) {
            removeClass(el, className);
        }
        else {
            addClass(el, className);
        }
    }

function translate(key) {
    var v = Local[key];
    if (v !== undefined) return v;
    return key;
}

function stopAll(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
}


// IE11 polyfills
(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('prepend')) {
            return;
        }
        Object.defineProperty(item, 'prepend', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function prepend() {
                var argArr = Array.prototype.slice.call(arguments),
                    docFrag = document.createDocumentFragment();

                argArr.forEach(function (argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });

                this.insertBefore(docFrag, this.firstChild);
            }
        });
    });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        function (selector) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(selector),
                i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) { }
            return i > -1;
        };
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this;

        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

function removeElement(el) {
    el.parentNode.removeChild(el);
}

function loadInto(el, url, callback, mime) {
    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function (e) {
        if (xhr.readyState === 4 && xhr.status === 200) {
            el.innerHTML = xhr.responseText;
            if (callback) callback();
        }
    };

    xhr.open("GET", url, true);
    xhr.setRequestHeader('Content-type', mime ? mime : 'text/html');
    xhr.send();
}

function customLog(level, ...args) {
    if (level < 0) {
        console.log(...args);
        return;
    }
    if (level > 0) {
        try {
            let err = {};
            args.forEach((a, i) => {
                err["p" + i] = a;
            });
            plausible(level > 1 ? "error" : "warn", { "props": err });
        }
        catch (error) {
            console.error("plausible", error);
            if (visibleLogging) {
                printError(2, ...args)
            }
        }
    }
    if (visibleLogging) {
        printError(level, ...args)
    }
    switch (level) {
        case 0:
            console.log(...args);
            break;
        case 1:
            console.warn(...args);
            break;
        case 2:
            console.error(...args);
            break;
        default:
            console.log(...args);
    }
}


function isElement(o) {
    try {
        return o instanceof HTMLElement;
    } catch (e) {
        return (typeof o === "object") &&
            (o.nodeType === 1) &&
            (typeof o.style === "object") &&
            (typeof o.ownerDocument === "object");
    }
}

var genericError = "Der er sket en fejl der ikke burde ske, vi beklager ulejligheden, prøv evt. igen om et par minutter.";
function showApiError(error, internal, extra) {
    if (internal) {
        if (error) {
            addOverlayMessage(error, extra);
        }
        addOverlayMessage(genericError, extra);
    }
    else {
        addOverlayMessage(error);
    }
}

function addOverlayMessage(msg, extra) {
    let body = document.querySelector("body");
    let overlay = document.querySelector("body > .overlay");
    if (!overlay) {
        addClass(body, "noscroll");
        body.insertAdjacentHTML("beforeend", '<div class="overlay"><div><div class="content"></div><a class="button close">OK</a></div></div>');
        overlay = document.querySelector("body > .overlay");

        overlay.addEventListener("click", function (e) {
            hideMessageOverlay();
            stopAll(e);
        });

        overlay.querySelector(".close").addEventListener("click", function (e) {
            hideMessageOverlay();
            stopAll(e);
        });

        overlay.firstChild.addEventListener("click", function (e) {
            stopAll(e);
        });
    }
    let content = overlay.querySelector(".content");
    let text = content.textContent;
    if (text.indexOf(msg) < 0) {
        if (msg.indexOf("<") >= 0 && msg.indexOf(">") >= 0) {
            content.insertAdjacentHTML("afterbegin", msg + (extra ? '<span class="extra">' + extra + "<br>" + new Error().stack.replace(/(?:\r\n|\r|\n)/g, '<br>') + '</span>' : ""));
        }
        else {
            content.insertAdjacentHTML("afterbegin", '<p>' + msg + '</p>' + (extra ? '<span class="extra">' + extra + "<br>" + new Error().stack.replace(/(?:\r\n|\r|\n)/g, '<br>') + '</span>' : ""));
        }
    }
}

function hideMessageOverlay() {
    let body = document.querySelector("body");
    let overlay = document.querySelector("body > .overlay");
    body.removeChild(overlay);
    removeClass(body, "noscroll");
}
﻿(function () {
    var location = window.location;
    var document = window.document;

    var scriptEl = document.currentScript;
    var endpoint = scriptEl.getAttribute("data-api") || defaultEndpoint(scriptEl);
    var hasDomainLanguage = scriptEl.getAttribute("data-domainLanguage") == "1";

    function onIgnoredEvent(reason, options) {
        if (reason) console.warn("Ignoring Event: " + reason);
        options && options.callback && options.callback();
    }

    function defaultEndpoint(el) {
        return new URL(el.src).origin + "/api/event";
    }

    function trigger(eventName, options) {
        if (
            location.protocol === "file:"
        ) {
            return onIgnoredEvent("localhost", options);
        }
        if (
            window._phantom ||
            window.__nightmare ||
            window.navigator.webdriver ||
            window.Cypress
        ) {
            return onIgnoredEvent(null, options);
        }
        try {
            if (window.localStorage.plausible_ignore === "true") {
                return onIgnoredEvent("localStorage flag", options);
            }
        } catch (e) { }

        var payload = {};
        let href = location.href.toLowerCase().replace("/?", "?");
        let referrer = document.referrer || null;
        if (referrer) {
            referrer = referrer.toLowerCase().replace("/?", "?");
            referrer = referrer.endsWith("/") ? referrer.substring(0, referrer.length - 1) : referrer;
        }
        payload.n = eventName;
        payload.u = href.endsWith("/") ? href.substring(0, href.length - 1) : href;
        payload.d = scriptEl.getAttribute("data-domain");
        payload.r = referrer;
        if (options && options.meta) {
            payload.m = JSON.stringify(options.meta);
        }
        if (options && options.props) {
            payload.p = options.props;
        }
        if (hasDomainLanguage) {
            let language = location.host.split('.')[0].split('-')[0];
            if (language && language.length == 2) {
                if (!payload.p) payload.p = {};
                payload.p.browserLanguage = navigator.language || navigator.userLanguage;
                payload.p.language = language;
            }
        }

        var propAttributes = scriptEl.getAttributeNames().filter(function (name) {
            return name.substring(0, 6) === "event-";
        });

        var props = payload.p || {};

        propAttributes.forEach(function (attribute) {
            var propKey = attribute.replace("event-", "");
            var propValue = scriptEl.getAttribute(attribute);
            props[propKey] = props[propKey] || propValue;
        });

        payload.p = props;

        // TODO: better send

        var url = endpoint;
        var data = JSON.stringify(payload);
        var callback = function () {
            options && options.callback && options.callback();
        }; // Replace with your actual callback function

        try {
            // Use Fetch API with keepalive
            fetch(url, {
                method: 'POST',
                keepalive: true,
                headers: {
                    'Content-Type': 'text/plain'
                },
                body: data
            }).then(() => {
                // Ignore the response
                if (typeof callback === 'function') {
                    callback();
                }
            }).catch((error) => {
                console.error('Error:', error);
                // Use XMLHttpRequest as a fallback
                var xhr = new XMLHttpRequest();
                xhr.open('POST', url, true);
                xhr.setRequestHeader('Content-Type', 'text/plain');
                xhr.send(data);
                xhr.onload = function () {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        if (typeof callback === 'function') {
                            callback();
                        }
                    }
                };
            });
        } catch (error) {
            console.error('Error:', error);
        }

        //    var request = new XMLHttpRequest();
        //    request.open("POST", endpoint, true);
        //    request.setRequestHeader("Content-Type", "text/plain");

        //    request.send(JSON.stringify(payload));

        //    request.onreadystatechange = function () {
        //        if (request.readyState === 4) {
        //            options && options.callback && options.callback();
        //        }
        //    };
    }

    var queue = (window.plausible && window.plausible.q) || [];
    window.plausible = trigger;
    for (var i = 0; i < queue.length; i++) {
        trigger.apply(this, queue[i]);
    }

    var lastPage;

    function page() {
        if (lastPage === location.pathname) return;
        lastPage = location.pathname;
        trigger("pageview");
    }

    var his = window.history;
    if (his.pushState) {
        var originalPushState = his["pushState"];
        his.pushState = function () {
            originalPushState.apply(this, arguments);
            page();
        };
        window.addEventListener("popstate", page);
    }

    function handleVisibilityChange() {
        if (!lastPage && document.visibilityState === "visible") {
            page();
        }
    }

    if (document.visibilityState === "prerender") {
        document.addEventListener("visibilitychange", handleVisibilityChange);
    } else {
        page();
    }
    function getLinkEl(link) {
        while (link && (typeof link.tagName === 'undefined' || !isLink(link) || !link.href)) {
            link = link.parentNode
        }
        return link
    }

    function isLink(element) {
        return element && element.tagName && element.tagName.toLowerCase() === 'a'
    }

    function shouldFollowLink(event, link) {
        // If default has been prevented by an external script, Plausible should not intercept navigation.
        if (event.defaultPrevented) { return false }

        var targetsCurrentWindow = !link.target || link.target.match(/^_(self|parent|top)$/i)
        var isRegularClick = !(event.ctrlKey || event.metaKey || event.shiftKey) && event.type === 'click'
        return targetsCurrentWindow && isRegularClick
    }

    var MIDDLE_MOUSE_BUTTON = 1

    function handleLinkClickEvent(event) {
        if (event.type === 'auxclick' && event.button !== MIDDLE_MOUSE_BUTTON) { return }

        var link = getLinkEl(event.target)
        var hrefWithoutQuery = link && link.href && link.href.split('?')[0]

        if (isElementOrParentTagged(link, 0)) {
            // Return to prevent sending multiple events with the same action.
            // Clicks on tagged links are handled by another function.
            return
        }
        if (isOutboundLink(link)) {
            return sendLinkClickEvent(event, link, { name: 'Outbound Link: Click', props: { url: link.href } })
        }
        if (isDownloadToTrack(hrefWithoutQuery)) {
            return sendLinkClickEvent(event, link, { name: 'File Download', props: { url: hrefWithoutQuery } })
        }
    }

    function sendLinkClickEvent(event, link, eventAttrs) {
        var followedLink = false

        function followLink() {
            if (!followedLink) {
                followedLink = true
                window.location = link.href
            }
        }

        if (shouldFollowLink(event, link)) {
            plausible(eventAttrs.name, { props: eventAttrs.props, callback: followLink })
            setTimeout(followLink, 5000)
            event.preventDefault()
        } else {
            plausible(eventAttrs.name, { props: eventAttrs.props })
        }
    }

    document.addEventListener('click', handleLinkClickEvent)
    document.addEventListener('auxclick', handleLinkClickEvent)

    function isOutboundLink(link) {
        return link && link.href && link.host && link.host !== location.host
    }
    var defaultFileTypes = ['pdf', 'xlsx', 'docx', 'txt', 'rtf', 'csv', 'exe', 'key', 'pps', 'ppt', 'pptx', '7z', 'pkg', 'rar', 'gz', 'zip', 'avi', 'mov', 'mp4', 'mpeg', 'wmv', 'midi', 'mp3', 'wav', 'wma']
    var fileTypesAttr = scriptEl.getAttribute('file-types')
    var addFileTypesAttr = scriptEl.getAttribute('add-file-types')
    var fileTypesToTrack = (fileTypesAttr && fileTypesAttr.split(",")) || (addFileTypesAttr && addFileTypesAttr.split(",").concat(defaultFileTypes)) || defaultFileTypes;

    function isDownloadToTrack(url) {
        if (!url) { return false }

        var fileType = url.split('.').pop();
        return fileTypesToTrack.some(function (fileTypeToTrack) {
            return fileTypeToTrack === fileType
        })
    }
    // Finds event attributes by iterating over the given element's (or its
    // parent's) classList. Returns an object with `name` and `props` keys.
    function getTaggedEventAttributes(htmlElement) {
        var taggedElement = isTagged(htmlElement) ? htmlElement : htmlElement && htmlElement.parentNode
        var eventAttrs = { name: null, props: {} }

        var classList = taggedElement && taggedElement.classList
        if (!classList) { return eventAttrs }

        for (var i = 0; i < classList.length; i++) {
            var className = classList.item(i)

            var matchList = className.match(/plausible-event-(.+)(=|--)(.+)/)
            if (!matchList) { continue }

            var key = matchList[1]
            var value = matchList[3].replace(/\+/g, ' ')

            if (key.toLowerCase() === 'name') {
                eventAttrs.name = value
            } else {
                eventAttrs.props[key] = value
            }
        }

        return eventAttrs
    }

    function handleTaggedFormSubmitEvent(event) {
        var form = event.target
        var eventAttrs = getTaggedEventAttributes(form)
        if (!eventAttrs.name) { return }

        event.preventDefault()
        var formSubmitted = false

        function submitForm() {
            if (!formSubmitted) {
                formSubmitted = true
                form.submit()
            }
        }

        setTimeout(submitForm, 5000)
        plausible(eventAttrs.name, { props: eventAttrs.props, callback: submitForm })
    }

    function isForm(element) {
        return element && element.tagName && element.tagName.toLowerCase() === 'form'
    }

    var PARENTS_TO_SEARCH_LIMIT = 3

    function handleTaggedElementClickEvent(event) {
        if (event.type === 'auxclick' && event.button !== MIDDLE_MOUSE_BUTTON) { return }

        var clicked = event.target

        var clickedLink
        var taggedElement
        // Iterate over parents to find the tagged element. Also search for
        // a link element to call for different tracking behavior if found.
        for (var i = 0; i <= PARENTS_TO_SEARCH_LIMIT; i++) {
            if (!clicked) { break }

            // Clicks inside forms are not tracked. Only form submits are.
            if (isForm(clicked)) { return }
            if (isLink(clicked)) { clickedLink = clicked }
            if (isTagged(clicked)) { taggedElement = clicked }
            clicked = clicked.parentNode
        }

        if (taggedElement) {
            var eventAttrs = getTaggedEventAttributes(taggedElement)

            if (clickedLink) {
                eventAttrs.props.url = clickedLink.href
                sendLinkClickEvent(event, clickedLink, eventAttrs)
            } else {
                plausible(eventAttrs.name, { props: eventAttrs.props })
            }
        }
    }

    function isTagged(element) {
        var classList = element && element.classList
        if (classList) {
            for (var i = 0; i < classList.length; i++) {
                if (classList.item(i).match(/plausible-event-name(=|--)(.+)/)) { return true }
            }
        }
        return false
    }

    function isElementOrParentTagged(element, parentsChecked) {
        if (!element || parentsChecked > PARENTS_TO_SEARCH_LIMIT) { return false }
        if (isTagged(element)) { return true }
        return isElementOrParentTagged(element.parentNode, parentsChecked + 1)
    }

    document.addEventListener('submit', handleTaggedFormSubmitEvent)
    document.addEventListener('click', handleTaggedElementClickEvent)
    document.addEventListener('auxclick', handleTaggedElementClickEvent)
})();

/*

    <form class="bwz-newsletter cf">
        <label for="name">Navn</label>
        <input type="text" id="name" name="name" required>

        <label for="email">Email</label>
        <input type="email" id="email" name="email" required>

        <!-- Hidden fields -->
        <input type="hidden" id="fid" name="fid" value="11">
        <input type="hidden" id="ucrc" name="ucrc" value="4F6B04BA75">

        <div class="message"></div>

        <input type="submit" id="submit-button" value="Tilmeld">
    </form>


 */

/**
 * Submits a form to BizWizard API
 * @param {string} name - The name field value
 * @param {string} email - The email field value
 * @param {string} fid - Form ID (hidden field)
 * @param {string} ucrc - UCRC value (hidden field)
 * @returns {Promise<Object>} - Response object with success status and data
 */
async function submitBizWizardForm(name, email, fid, ucrc) {
    const url = `https://app.bwz.se/cyklistforbundet/b/f/?fid=${fid}&ucrc=${ucrc}`;

    const formData = {
        "Name": name,
        "E-mail": email
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: {
                // 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                // 'Content-Type': 'text/plain',
                'Content-Type': 'application/json',
                // 'Accept-Language': 'en|se|no|fi|da'
            },
            body: JSON.stringify(formData)
        });

        const result = await response.json();

        if (result.successful) {
            return handleSuccessfulSubmissionBWZ(result);
        } else {
            return handleFailedSubmissionBWZ(result);
        }

    } catch (error) {
        return handleNetworkErrorBWZ(error);
    }
}

/**
 * Handles successful form submissions
 * @param {Object} result - The successful response from BizWizard
 * @returns {Object} - Formatted success response
 */
function handleSuccessfulSubmissionBWZ(result) {
    let message = '';

    switch (result.optInResultCode) {
        case 1:
            message = 'Din email er nu tilmeldt.';
            break;
        case 2:
            message = 'Din email er allerede tilmeldt.';
            break;
        case 3:
            message = 'Check din email for at bekræfte din tilmelding.';
            break;
        default:
            message = 'Form afsendt!';
    }

    return {
        success: true,
        message: message,
        data: {
            optInResultCode: result.optInResultCode,
            optInResultCodeText: result.optInResultCodeText,
            recipientId: result.recipientId,
            isNewRecipient: result.isNewRecipient,
            formResponseId: result.formResponseId,
            redirectUrl: result.redirectUrl
        }
    };
}

/**
 * Handles failed form submissions
 * @param {Object} result - The failed response from BizWizard
 * @returns {Object} - Formatted error response
 */
function handleFailedSubmissionBWZ(result) {
    const errorMessages = {
        1: 'Invalid form field data provided.',
        2: 'This form is currently closed for registration.',
        3: 'This form is not yet open for registration.',
        4: 'This form has been deleted.',
        5: 'Email field is required but not found.',
        6: 'This form does not accept JSON submissions.'
    };

    let mainError = errorMessages[result.errorCode] || 'An unknown error occurred.';
    let fieldErrors = [];

    if (result.fieldValidationErrors && result.fieldValidationErrors.length > 0) {
        fieldErrors = result.fieldValidationErrors.map(error => ({
            field: error.formFieldName,
            message: error.errorMessage,
            errorCode: error.errorCode,
            errorCodeText: error.errorCodeText
        }));
    }

    return {
        success: false,
        message: mainError,
        errorCode: result.errorCode,
        errorCodeText: result.errorCodeText,
        fieldErrors: fieldErrors
    };
}

/**
 * Handles network or other errors
 * @param {Error} error - The error that occurred
 * @returns {Object} - Formatted error response
 */
function handleNetworkErrorBWZ(error) {
    return {
        success: false,
        message: 'Network error occurred. Please try again later.',
        error: error.message
    };
}
function initBWZNewsletterForms() {
    const forms = document.querySelectorAll('.bwz-newsletter');
    forms.forEach(form => {
        bwzNewsletterForm(form);
    });
}
function bwzNewsletterForm(form) {
    const submitButton = form.querySelector("input[type=submit]");
    const messageDiv = form.querySelector('.message');

    if (form) {
        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            // Disable submit button during submission
            submitButton.disabled = true;

            // Clear previous messages
            messageDiv.innerHTML = '';
            messageDiv.className = '';

            // Get form values
            const name = document.getElementById('name').value;
            const email = document.getElementById('email').value;
            const fid = document.getElementById('fid').value;
            const ucrc = document.getElementById('ucrc').value;

            try {
                const result = await submitBizWizardForm(name, email, fid, ucrc);

                if (result.success) {
                    messageDiv.innerHTML = `<p class="success">${result.message}</p>`;
                    messageDiv.className = 'success';

                    // Redirect if URL is provided
                    if (result.data.redirectUrl) {
                        setTimeout(() => {
                            window.location.href = result.data.redirectUrl;
                        }, 2000);
                    }

                    // Clear form on success
                    form.reset();
                } else {
                    let errorHtml = `<p class="error">${result.message}</p>`;

                    // Display field-specific errors
                    if (result.fieldErrors && result.fieldErrors.length > 0) {
                        errorHtml += '<ul class="field-errors">';
                        result.fieldErrors.forEach(fieldError => {
                            errorHtml += `<li><strong>${fieldError.field}:</strong> ${fieldError.message}</li>`;
                        });
                        errorHtml += '</ul>';
                    }

                    messageDiv.innerHTML = errorHtml;
                    messageDiv.className = 'error';
                }
            } catch (error) {
                messageDiv.innerHTML = `<p class="error">An unexpected error occurred. Please try again.</p>`;
                messageDiv.className = 'error';
                console.error('Form submission error:', error);
            } finally {
                // Re-enable submit button
                submitButton.disabled = false;
            }
        });
    }
}

// Initialize form handler when DOM is loaded
document.addEventListener('DOMContentLoaded', initBWZNewsletterForms);
﻿function trackEvent(eventName, eventType, data) {
    try {
        var trackerName = ga.getAll()[0].get('name');
        ga(trackerName + '.send', 'event', { eventCategory: eventName, eventAction: eventType, eventLabel: data });
    }
    catch (err) {
        log("ga not available: " + eventName + " , " + eventType + " , " + data, true);
    }
    try {
        var fbData = {};
        fbData[eventType] = "" + data
        fbq('track', eventName, fbData);
    }
    catch (err) {
        log("fbq not available: " + eventName + " , " + eventType + " , " + data, true);
    }
}

﻿addDomReadyEventListener((e) => {
    var elements = document.querySelectorAll('input,select,textarea');
    var invalidListener = function () { this.scrollIntoView(false); };

    for (var i = elements.length; i--;) {
        elements[i].addEventListener('invalid', invalidListener);
    }

    addEvents(document.querySelectorAll("form.api"), "submit", function (e) {
        let autocompleteError = document.getElementById("autocompleteError");
        let formattedAddress = e.target.querySelector("#selectedFormattedAddress");
        if (formattedAddress && autocompleteError) {
            if (formattedAddress.value == "") {
                autocompleteError.innerHTML = '<h3>Vælg en addresse i listen når din fulde adresse bliver vist.</h3>';
                return stopAll(e);
            }
            else {
                autocompleteError.innerHTML = "";
            }
        }
        httpr(e.target.getAttribute("data-target"), function (data) {
            console.log(data);
            if (!data.HasError) {
                let url = e.target.getAttribute("data-success");
                if (url.indexOf("+/") == 0) {
                    url = "/" + document.location.pathname.split("/").filter(e => e) + url.substring(1);
                }
                document.location = url;
            }
        }, new FormData(e.target), e.target);
        return stopAll(e);
    });

    addEvents(document.querySelectorAll("form.simple"), "submit", function (e) {
        httpr("/umbraco/surface/membershipsurface/" + e.target.getAttribute("data-method"), undefined, new FormData(e.target), e.target);
        return stopAll(e);
    });

    addEvent("#update", "submit", function (e) {
        let pw = e.target.querySelector("input[name=password]");
        let newpw = e.target.querySelector("input[name=newpassword]");
        let pwe = e.target.querySelector("span[for=password]");

        if ((newpw.value || pw.value) && pw.value !== newpw.value) {
            removeClass(pwe, "hidden");
            return stopAll(e);
        }
        else {
            addClass(pwe, "hidden");
        }

        httpr("/umbraco/surface/membershipsurface/update", undefined, new FormData(e.target), e.target);
        return stopAll(e);
    });

    addEvent("#signup select", "change", function (e) {
        let v = e.target.value;
        let f = e.target.closest("form");
        if (f) {
            let d = f.querySelector("div[data-type='H']");
            if (v.indexOf(",H") > 0) {
                removeClass(d, "hidden");
            }
            else {
                addClass(d, "hidden");
            }
        }
    });

    addEvent("#signup", "submit", function (e) {
        let sue = {
            'event': 'signupInitated',
            'mebershipType': e.target.querySelector("select[name='type']").value,
            'newsletterOptOut': e.target.querySelector("input[name='newsletter']").checked
        };
        dataLayer.push(sue);
        httpr("/umbraco/surface/membershipsurface/savebeforepayment", function (paymentUrl) {
            console.log(paymentUrl);
            if (paymentUrl && paymentUrl.indexOf("https") === 0) {
                document.location.href = paymentUrl;
            }
            else {
                alert("Betalingssystemet er i øjeblikket nede, vi arbejder på sagen, kontakt os eventuelt på tlf 33 32 31 21  eller email post@cyklistforbundet.dk");
            }
        }, new FormData(e.target), e.target);
        return stopAll(e);
    });

});
﻿function webPsupport(callback) {
    var webP = new Image();
    webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
    webP.onload = webP.onerror = function () {
        callback(webP.height === 2);
    };
}

addDomReadyEventListener(() => {
    webPsupport(function (hasWebP) {
        let skipSteppingSize = [370, 570, 1170];
        forEach("img[data-src]", function (img) {
            if (img.closest("[data-masonry-grid]")) return;
            if (hasClass(img, "lazy")) return;
            if (!isVisible(img)) {
                addClass(img, "lazy");
                return;
            }
            let mode = img.closest(".images") ? "max" : "crop";
            let src = img.getAttribute("data-src")?.toLowerCase();
            let isPNG = src.indexOf(".png") > 0;
            let height = img.clientHeight;
            let width = img.clientWidth;
            let uw = img.getAttribute("data-uw");
            if (uw && width > uw) width = uw;
            let allowSizeSteps = true;
            if (hasClass(img, "defaultAspect")) {
                if (uw) {
                    img.style.maxWidth = uw + "px";
                    if (uw < width) {
                        width = uw;
                        allowSizeSteps = false;
                    }
                }
                if (img.getAttribute("data-aspect")) {
                    height = width * img.getAttribute("data-aspect");
                }
                else {
                    height = "";
                }
            }
            if (hasClass(img, "sizebyheight")) {
                height = img.parentNode.clientHeight;
                width = "";
            }
            let pe = img.parentElement;
            if (width <= 1) {
                while (pe) {
                    width = pe.offsetWidth;
                    if (width > 1) {
                        break;
                    }
                    else {
                        pe = pe.parentElement;
                    }
                }
            }

            if (allowSizeSteps && width && skipSteppingSize.indexOf(width) < 0) {
                let stepSize = 10;
                if (width > 1200) {
                    stepSize = 200;
                }
                else if (width > 600) {
                    stepSize = 100;
                }
                else if (width > 300) {
                    stepSize = 50;
                }
                let steppedWidth = Math.ceil(width / stepSize) * stepSize;
                let steppedHeight = height ? Math.round(height / width * steppedWidth) : height;
                width = steppedWidth;
                height = steppedHeight;
            }

            if ((pe === img.parentElement) && pe.tagName !== 'DIV' && pe.closest('article')) height = 0;

            if (src.indexOf(".svg") < 0) {
                src = src.split('?')[0] + "?quality=80&rmode=" + mode + "&width=" + (width <= 0 ? "" : width) + "&height=" + (height <= 1 ? "" : height) + (img.getAttribute("data-center") ? "&rxy=" + img.getAttribute("data-center") : "") + (hasWebP && !isPNG ? "&format=webp" : "") + (hasClass(img, "preflow") ? "&autorotate=true" : "");
            }
            img.addEventListener("load", function (e) {
                var parent = e.target.parentNode;
                if (parent) {
                    setTimeout(function () { addClass(parent, "hlc"); }, 300);
                    if (parent.classList.contains("img")) addClass(parent, "lazyloaded");
                }
                img.removeAttribute("data-src");
                addClass(img, "lazyloaded");
            });
            img.setAttribute("loading", "lazy");
            img.setAttribute("src", src);
            if (hasClass(img.parentNode, "contain")) {
                img.parentNode.setAttribute("data-bg", "url(" + img.getAttribute("data-src") + ")");
            }
        });
    });
});

function injectSVG(el) {
    let src = el.src;
    let parent = el.parentNode;
    removeElement(el);
    loadInto(parent, src, function () { }, "image/svg+xml");
}

﻿var enableLog = true;
var enableLogDebug = true;

//var videoAccept = '<div class="cookieconsent-optout-statistics">Du skal <a href="javascript:Cookiebot.renew()">acceptere marketing cookies</a> for at se video.</div>';
//$(function () {
//    if (window.videoAccept !== undefined) $("iframe[data-cookieconsent]").closest(".embed-container").before(videoAccept);
//    $("iframe[data-cookieconsent]").each(function () {
//        $(this).attr("src", $(this).attr("data-src"));
//    });
//});

function isIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./) ? true : false;
}

window.addEventListener('resize', function () {
    forEach(".preflow", function (el) {
        el.removeAttribute("width");
        el.removeAttribute("height");
    });
});
addDomReadyEventListener((e) => {
    if (isIE()) {
        var h = document.querySelector("html");
        addClass(h, "ie");
        cssVars({
        });
        //var h = document.querySelector(".sticky");
        //var warn = document.createElement("div");
        //addClass(warn, "ie");
        //removeClass(h, "sticky");
        //warn.innerHTML = '<p>Cyklistforbundets hjemmeside kan ikke ses via Internet Explorer-browseren.</p><p>Vi anbefaler, at du tilgår vores hjemmeside via nyere versioner af Firefox, Chrome, Safari eller Edge for at få den bedste oplevelse.</p>';
        //h.parentNode.insertBefore(warn, h);
    }

    addEvents(".gallery img", "click", function (e) {
        let src = e.target.src;
        if (src) {
            src = src.split('?')[0] + '?quality=80&mode=crop&upscale=false&width=1200&format=webp';
            window.open(src);
        }
    });

    var someshare = document.querySelector("li.share");
    if (someshare) {
        var url = window.location.href.split('?')[0].split('#')[0];
        var canonical = document.querySelector("link[rel='canonical']");
        if (canonical) url = canonical.getAttribute("href");

        let sh = someshare.querySelector(".tw");
        if (sh) sh.setAttribute("href", "http://twitter.com/share?text=&hashtags=cyklistforbundet&url=" + encodeURIComponent(url));
        sh = someshare.querySelector(".fb");
        if (sh) sh.setAttribute("href", "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url));
    }

    forEach(".banner .bike", function (el) {
        var url = cssVar("logocykel" + el.getAttribute("data-bike"));
        var svg = decodeURIComponent(url.substring(url.indexOf(",") + 1, url.indexOf(")") - 1));
        el.innerHTML = svg;
    });

    let mega = document.querySelector("nav.mega > ul");
    if (mega) {
        forEach(".stick a", function (el) {
            if (!hasClass(el, "button") && !hasClass(el, "search") && el.innerHTML != '') {
                let li = document.createElement("li");
                addClass(li, "added");
                li.innerHTML = el.outerHTML;
                mega.prepend(li);
            }
        });
    }

    // search
    let targetId = "searchWidgetTrigger";
    let scriptUrl = "https://cloud.google.com/ai/gen-app-builder/client?hl=da_DK";

    let loadPromise = null;
    let widgetReadyPromise = null;
    function waitForWidgetReady() {
        if (widgetReadyPromise) return widgetReadyPromise;

        widgetReadyPromise = loadScriptOnce(scriptUrl).then(function () {
            // Wait for the custom element to be registered
            if (window.customElements && customElements.whenDefined) {
                return customElements.whenDefined("gen-search-widget");
            }

            // Fallback for very old browsers [assumption]
            return new Promise(function (resolve) {
                let maxWait = 5000;
                let start = Date.now();

                (function check() {
                    if (customElements && customElements.get && customElements.get("gen-search-widget")) {
                        resolve();
                        return;
                    }
                    if (Date.now() - start > maxWait) {
                        resolve();
                        return;
                    }
                    setTimeout(check, 50);
                })();
            });
        });

        return widgetReadyPromise;
    }

    function loadScriptOnce(src) {
        if (loadPromise) return loadPromise;

        loadPromise = new Promise(function (resolve, reject) {
            let s = document.createElement("script");
            s.src = src;
            s.async = true;
            s.onload = resolve;
            s.onerror = function () {
                reject(new Error("Failed to load script: " + src));
            };
            document.head.appendChild(s);
        });

        return loadPromise;
    }

    let triggers = document.querySelectorAll('[id="' + targetId + '"]');

    triggers.forEach(function (el) {
        el.addEventListener("click", function (event) {
            loadScriptOnce(scriptUrl).catch(console.error);

            let trigger = el;
            if (!trigger) return;

            // Ignore the synthetic click we dispatch ourselves
            if (trigger.dataset.widgetSyntheticClick === "1") {
                trigger.dataset.widgetSyntheticClick = "";
                return;
            }

            // If widget is not ready yet, consume this click, load script, then replay click
            let widgetDefined =
                window.customElements &&
                customElements.get &&
                customElements.get("gen-search-widget");

            if (!widgetDefined) {
                event.preventDefault();
                event.stopPropagation();

                waitForWidgetReady()
                    .then(function () {
                        // Re-dispatch click on the original trigger so Google's listener can open the widget
                        trigger.dataset.widgetSyntheticClick = "1";
                        trigger.dispatchEvent(new MouseEvent("click", {
                            bubbles: true,
                            cancelable: true,
                            view: window
                        }));
                    })
                    .catch(function (err) {
                        console.error(err);
                    });
            }
        });
    });

    addEvent("nav.mega", "click", function (e) {
        e.stopPropagation();
    });

    addEvent(".burger", "click", function (e) {
        toggleClass("nav.mega", "showMobile");
        document.getElementById("burger-check").checked = !document.getElementById("burger-check").checked;
        return stopAll(e);
    });

    addEvents(".main a, .sub a:not(.search)", "click", function (e) {
        if (hasClass(e.target, "show")) {
            hideMenu();
        }
        else {
            let mega = document.querySelector("nav.mega");
            removeClass(mega, "showMobile");
            document.getElementById("burger-check").checked = false;

            return showMenu(e.target, e);
        }
        return stopAll(e);
    });

    addEvents(".toggler", "click", function (e) {
        toggle(e);
    });

    addEvent(".sub form", "click", function (e) {
        e.stopPropagation();
    });

    addEvent("body", "click", function (e) {
        removeClass(document.querySelector("a.search"), "out");
        hideMenu();
    });

    forEach("div.limit", function (el) {
        if (el.offsetHeight > 150) {
            addClass(el, "limited");
            el.addEventListener("click", function (e) {
                removeClass(e.target, "limited");
                e.target.outerHTML = e.target.outerHTML;
                stopAll(e);
            });
        }
    });


    var pop = document.querySelector("div.pop");
    if (pop) {
        let popId = pop.dataset.id;
        let popKey = "pop" + popId;
        let today = new Date().toISOString().split('T')[0];
        let lastShown = localStorage.getItem(popKey);
        if (!lastShown || lastShown != today) {
            localStorage.setItem(popKey, today);
            const dialog = document.getElementById('imageDialog');
            dialog.addEventListener("close", (e) => {
                document.body.classList.remove("noscroll");
            });
            dialog.querySelector("form").insertAdjacentHTML("beforeend", pop.outerHTML);

            let delay = pop.dataset.delay;
            if (delay) {
                setTimeout(function () { document.body.classList.add("noscroll"); dialog.showModal(); }, delay * 1000);
            }
            else {
                document.body.classList.add("noscroll");
                dialog.showModal();
            }
        }
    }

    if (window.gtmId !== undefined && window.gtmId !== '') {
        (function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', gtmId);
    }
});

function toggle(e) {
    let toggle = e.target;
    if (hasClass(toggle, "off")) {
        removeClass(toggle, "off");
    }
    else {
        addClass(toggle, "off");
    }
}

function hideMenu() {
    let mega = document.querySelector("nav.mega");
    addClass(mega, "hidden");
    removeClass(mega, "showMobile");
    document.getElementById("burger-check").checked = false;

    forEach(".main a, .sub a:not(.search)", function (el) {
        removeClass(el, "show");
    });
}

function showMenu(el, e) {
    forEach(".main a, .sub a:not(.search)", function (el) {
        removeClass(el, "show");
    });
    addClass(el, "show");

    var href = el.getAttribute("href");
    var myMenu = hasClass(el, "myMenu");
    var solo = false;
    forEach(".mega > ul > li > a", function (elx) {
        if (elx.getAttribute("href") === href) {
            if (!solo && !myMenu) solo = hasClass(elx, "solo");
            removeClass(elx.parentNode, "hidden");
        }
        else {
            addClass(elx.parentNode, "hidden");
        }
    });
    if (solo) return;

    removeClass(document.querySelector("nav.mega"), "hidden");

    if (e) return stopAll(e);
}


    /*
function showMenu(el, e) {
    forEach(".main a, .sub a:not(.search)", function (el) {
        removeClass(el, "show");
    });
    addClass(el, "show");

    try {
        var href = el.getAttribute("href");
        var myMenu = hasClass(el, "myMenu");
        var solo = false;
        forEach(".mega > ul > li > a", function (elx) {
            if (elx.getAttribute("href") === href) {
                if (!solo) solo = hasClass(elx, "solo");
                removeClass(elx.parentNode, "hidden");
            }
            else {
                if (myMenu) {
                    removeClass(elx.parentNode, "hidden");
                }
                else {
                    addClass(elx.parentNode, "hidden");
                }
            }
        });
        if (solo) return;

        removeClass(document.querySelector("nav.mega"), "hidden");
    }
    catch (err) {
        console.error(err);
    }

    if (e) return stopAll(e);
}




        let myMenu = el.classList.hasClass("myMenu");
    var solo = false;
    forEach(".mega > ul > li > a", function (elx) {
        if (elx.getAttribute("href") === href) {
            if (!solo) solo = hasClass(elx, "solo");
            removeClass(elx.parentNode, "hidden");
        }
        else {

            addClass(elx.parentNode, "hidden");
        }
    });
    console.log(el, href, myMenu, solo);

    */
